export const screenSizes = {
  XL: 1280,
  LG: 1024,
  MD: 768,
  SM: 640,
  XS: 520,
};
